import React, { useState, useEffect } from "react"
import { Trailer, Edit } from "../../images/"
import { Input } from "@fourkites/elemental-input"
import BottomBar from "../../components/BottomBar/bottombar"
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight"
import { useHistory, useLocation } from "react-router"
import AlertIcon from "components/AlertIcon/alertIcon"
import { useDispatch, useSelector } from "react-redux"
import "./KioskUSDOT.css"
import { RootState } from "store/store"
import { http } from "utils/http"
import { apiEndPoints } from "constants/apiEndpoints"
import { toast } from "react-toastify"
import { Trans, useTranslation } from "react-i18next"
import i18next from "i18next"

const KioskTrailer = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const [invalidPhone, setinvalidPhone] = useState(false)
  const [disabledProceed, setdisabledProceed] = useState(true)
  const [disabledPhone, setdisabledPhone] = useState(false)
  const [TrailerNumber, setTrailerNumber] = useState("")
  const [visitId, setVisitId] = useState()
  const [isEdit, setIsEdit] = useState(false)
  const [isReadonly, setIsReadonly] = useState(false)
  const assetReducer = useSelector((state: RootState) => state.assetReducer)
  const visitReducer = useSelector((state: RootState) => state.visitReducer)
  const dispatch = useDispatch()

  useEffect(() => {
    setTrailerNumber(assetReducer.asset.trailer)
    setVisitId(visitReducer.visit.id)
    if (assetReducer.asset.trailer.length > 0) {
      setIsReadonly(true)
    }
  }, [])
  useEffect(() => {
    if (TrailerNumber.trim().length > 0) {
      setdisabledProceed(false)
    } else {
      setdisabledProceed(true)
    }
  }, [TrailerNumber])

  const handlePaste = (limit: number) => {
    let truncatTrailerNumber = TrailerNumber.substring(0, limit)
    setTrailerNumber(truncatTrailerNumber)
  }

  const setTrailerDetails = () => {
    let asset = {
      ...assetReducer.asset,
      trailer: TrailerNumber
    }

    dispatch({
      type: "SET_ASSET_INFO",
      payload: asset
    })

    http
      .post(
        `${apiEndPoints.activities}${visitId}/activities`,
        {
          type: "trailer-details-submitted",
          mode: "kiosk",
          details: {
            assetDetails: {
              trailer: {
                number: TrailerNumber
              }
            }
          }
        },
        {}
      )
      .then(res => {
        history.push("/kiosk-trailer-type")
      })
      .catch(err => toast.error(err.response.data.error))
  }

  const onClickEdit = () => {
    setIsEdit(true)
    setIsReadonly(false)
  }
  const trans = (key: string) => {
    return i18next.t(key) || ""
  }
  return (
    <>
      <div className="container">
        <div className="header-text">
          {isReadonly ? (
            <>
              <Trans
                i18nKey="validate_your_trailer_name"
                components={{ newLine: <br /> }}
              />{" "}
            </>
          ) : (
            ""
          )}

          {!isReadonly ? (
            <>
              {" "}
              <Trans
                i18nKey="enter_your_trailer_number_with_br"
                components={{ newLine: <br /> }}
              />
            </>
          ) : (
            ""
          )}
        </div>
        <div style={{ display: "flex", width: "65%" }}>
          <div style={{ width: "100%" }}>
            <div
              className={` driver-input driver-input-USDOT-font ${
                invalidPhone ? "error-label" : ""
              }`}
            >
              <Input
                autoFocus={true}
                className={`${invalidPhone ? "error-label" : ""}`}
                placeholder={trans("enter_trailer_here")}
                label={trans("trailer_number")}
                defaultValue={TrailerNumber}
                maxLength={20}
                readOnly={isReadonly}
                disabled={disabledPhone}
                hideLabel={false}
                invalid={invalidPhone}
                onChange={event => setTrailerNumber(event.target.value)}
                onPaste={e => handlePaste(20)}
                errorLabel={invalidPhone ? trans("trailer_not_valid") : ""}
                icon={
                  invalidPhone ? (
                    <AlertIcon className="elemental-Input-icon--invalid" />
                  ) : TrailerNumber && !isEdit && isReadonly ? (
                    <img src={Edit} className="edit" onClick={onClickEdit} />
                  ) : (
                    <></>
                  )
                }
              />
            </div>
          </div>
          <div style={{ margin: "auto" }}>
            <img src={Trailer} />
          </div>
        </div>
      </div>
      <BottomBar
        disabled={disabledProceed}
        onClick={() => setTrailerDetails()}
        text={t(isReadonly ? "looks_good_continue" : "continue")}
        endIcon={<KeyboardArrowRightIcon />}
      />
    </>
  )
}
export default KioskTrailer
